
  
/* =============================================================================
   CUSTOM SCRIPTS - SHOPIFY
   =============================================================================

   TABLE DES MATIÈRES
   ------------------
   1. Paris      — Carte interactive (dots avec overlays)
   2. Scène      — Popups sur points d'intérêt
   3. Collection — Filtres actifs dupliqués (sidebar → header)
   4. Produit    — Galerie scrollable au changement de variant
   5. Navigation — Bouton collection aléatoire
   6. Panier     — Texte upsell dynamique (#156)
   7. Produit    — Image ambiance & disponibilité variant (#167)
   8. Wishlist   — Texte dynamique selon nb articles (#172)
   9. Collection — Compteur de produits en temps réel (#175)

   ============================================================================= */


/* =============================================================================
   1. PARIS — Carte interactive
   ============================================================================= */

document.addEventListener('DOMContentLoaded', function () {
  const dots = document.querySelectorAll('.paris-rue-dott');
  const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  dots.forEach(function (dot) {
    const overlay = dot.querySelector('.paris-rue-overlay');
    if (!overlay) return;

    /* Desktop : hover classique */
    if (!isMobile) {
      dot.addEventListener('mouseenter', function () {
        overlay.classList.add('is-visible');
      });
      dot.addEventListener('mouseleave', function () {
        overlay.classList.remove('is-visible');
      });
      return;
    }

    /* Mobile : 1er clic → ouvre l'overlay / 2e clic → navigation */
    let overlayOpen = false;

    dot.addEventListener('click', function (e) {
      if (!overlayOpen) {
        e.preventDefault();
        overlay.classList.add('is-visible');
        overlayOpen = true;
      }
    });

    overlay.addEventListener('click', function () {
      window.location.href = dot.href;
    });

    document.addEventListener('click', function (e) {
      if (!dot.contains(e.target)) {
        overlay.classList.remove('is-visible');
        overlayOpen = false;
      }
    });
  });
});


/* =============================================================================
   2. SCÈNE — Popups sur points d'intérêt
   ============================================================================= */

document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.scene-popup-container');
  if (!containers.length) return;

  let openedOverlay = null;

  containers.forEach(function (container) {
    const button  = container.querySelector('.scene__dot__button');
    const overlay = container.querySelector('.scene-popup-overlay');
    if (!button || !overlay) return;

    overlay.classList.remove('is-visible');

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      /* Même overlay déjà ouvert → fermer */
      if (overlay === openedOverlay && overlay.classList.contains('is-visible')) {
        overlay.classList.remove('is-visible');
        openedOverlay = null;
        return;
      }

      /* Fermer l'overlay précédent puis ouvrir celui-ci */
      if (openedOverlay) {
        openedOverlay.classList.remove('is-visible');
      }

      overlay.classList.add('is-visible');
      openedOverlay = overlay;
    });
  });
});


/* =============================================================================
   3. COLLECTION — Filtres actifs dupliqués (sidebar → header)
   ============================================================================= */

(function () {
  'use strict';

  const SIDEBAR_SELECTOR = '[data-collection-sidebar]';
  const SOURCE_SELECTOR  = '[data-active-filters-source]';
  const TARGET_SELECTOR  = '[data-active-filters-target]';

  function cloneActiveFilters(sidebar) {
    const source  = sidebar.querySelector(SOURCE_SELECTOR);
    const targets = document.querySelectorAll(TARGET_SELECTOR);

    targets.forEach(function (target) {
      if (source) {
        target.innerHTML = source.innerHTML;
        target.classList.remove('hidden');
      } else {
        target.innerHTML = '';
        target.classList.add('hidden');
      }
    });
  }

  function observeSidebar() {
    const sidebar = document.querySelector(SIDEBAR_SELECTOR);
    if (!sidebar) return;

    const observer = new MutationObserver(function () {
      cloneActiveFilters(sidebar);
    });

    observer.observe(sidebar, { childList: true, subtree: true });

    /* Exécution initiale au chargement */
    cloneActiveFilters(sidebar);
  }

  document.addEventListener('DOMContentLoaded', observeSidebar);
})();


/* =============================================================================
   4. PRODUIT — Galerie scrollable au changement de variant (#119)
   ============================================================================= */

document.addEventListener('change', function (e) {
  const input = e.target;

  if (
    !input.matches('.radio__buttons input[type="radio"]') ||
    !input.dataset.optionValueId
  ) return;

  const featuredMediaId = input.dataset.mediaId || null;
  const slider = document.querySelector('[data-grid-slider]');

  if (!slider) {
    console.warn('Slider introuvable !');
    return;
  }

  const targetSlide = slider.querySelector(`[data-media-id="galerieproduct-${featuredMediaId}"]`);

  if (!targetSlide) {
    console.warn('Slide cible introuvable !');
    return;
  }

  slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });

  /* Debug */

  const mesData = document.getElementById('Mesdata');
  if (mesData && featuredMediaId) {
    mesData.textContent = featuredMediaId;
  }
});


/* =============================================================================
   5. NAVIGATION — Bouton collection aléatoire (#76)
   ============================================================================= */

document.addEventListener('DOMContentLoaded', function () {
  const randomBtn    = document.getElementById('random-collection-btn');
  const randomBtnMob = document.getElementById('random-collection-btn-mob');

  if (!randomBtn) return;

  const collectionsData = randomBtn.getAttribute('data-collections');
  if (!collectionsData) return;

  let collections;
  try {
    collections = JSON.parse(collectionsData);
  } catch (e) {
    console.warn('Impossible de parser collections_json', e);
    return;
  }

  if (!Array.isArray(collections) || collections.length === 0) return;

  const randomUrl = collections[Math.floor(Math.random() * collections.length)];

  randomBtn.setAttribute('href', randomUrl);
  if (randomBtnMob) randomBtnMob.setAttribute('href', randomUrl);
});


/* =============================================================================
   6. PANIER — Texte upsell dynamique (#156)
   ============================================================================= */

/* =============================================================================
   6. PANIER — Texte upsell dynamique
   ============================================================================= */

/* =============================================================================
   6. PANIER — Texte upsell dynamique
   ============================================================================= */

(function () {
  'use strict';

  const CART_COUNT_SELECTOR = 'cart-count.cart__items-count';

  function getCartCount(fallback) {
    const cartCountEl = document.querySelector(CART_COUNT_SELECTOR);

    const value =
      fallback ??
      (cartCountEl && cartCountEl.dataset.cartCount) ??
      (cartCountEl && cartCountEl.textContent);

    return Number.parseInt(value, 10);
  }

  function upsell(cartCount) {
    const items = [];

    for (let i = 1; i <= 4; i++) {
      items.push({
        title: document.getElementById('itemx' + i + 'title'),
        subtitle: document.getElementById('itemx' + i)
      });
    }

    const hasUpsellElements = items.some(function (item) {
      return item.title || item.subtitle;
    });

    /* Le tiroir panier n’est pas encore rendu */
    if (!hasUpsellElements) {
      return false;
    }

    /* Tout masquer */
    items.forEach(function (item) {
      if (item.title) {
        item.title.classList.add('display_none');
      }

      if (item.subtitle) {
        item.subtitle.classList.add('display_none');
      }
    });

    const count = Number.parseInt(cartCount, 10);

    if (!Number.isFinite(count) || count <= 0) {
      return true;
    }

    const index = Math.min(count - 1, items.length - 1);
    const target = items[index];

    if (!target) {
      return true;
    }

    if (target.title) {
      target.title.classList.remove('display_none');
    }

    if (target.subtitle) {
      target.subtitle.classList.remove('display_none');
    }

    return true;
  }

  function refreshUpsell(cartCount) {
    setTimeout(function () {
      const count = getCartCount(cartCount);

      if (!upsell(count)) {
        setTimeout(function () {
          upsell(getCartCount());
        }, 400);
      }
    }, 250);
  }

  document.addEventListener('theme:cart:change', function (event) {
    const count =
      event &&
      event.detail &&
      event.detail.cartCount;

    refreshUpsell(count);
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshUpsell();

    const observer = new MutationObserver(function () {
      if (document.getElementById('itemx1')) {
        refreshUpsell();
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();


/* =============================================================================
   7. PRODUIT — Image ambiance & disponibilité variant (#167)
   ============================================================================= */

function showAmbiance(id) {
  document.querySelectorAll('.image_ambiance').forEach(function (img) {
    img.classList.remove('visible');
  });
  const target = document.getElementById(id);
  if (target) target.classList.add('visible');
}
function syncOrderAvailability(isAvailable) {
  const source = document.getElementById(
    isAvailable ? 'variant-available' : 'variant-unavailable'
  );

  if (!source || !source.dataset.orderAvailability) return;

  const availabilityValue = source.dataset.orderAvailability;

  document
    .querySelectorAll('form[action*="/cart/add"]')
    .forEach(function (form) {
      let input = form.querySelector(
        'input[name="properties[Disponibilité]"]'
      );

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Disponibilité]';
        form.appendChild(input);
      }

      input.value = availabilityValue;
    });
}
function showqtt(varvalue) {
  const selectedVar = document.getElementById('inv-' + varvalue);
  if (!selectedVar) return;

  const available = document.getElementById('variant-available');
  const unavailable = document.getElementById('variant-unavailable');
  const isAvailable =
    selectedVar.dataset.inventory === 'available';

  if (available) {
    available.style.display = isAvailable ? 'flex' : 'none';
  }

  if (unavailable) {
    unavailable.style.display = isAvailable ? 'none' : 'flex';
  }

  syncOrderAvailability(isAvailable);
}

document.addEventListener('DOMContentLoaded', function () {
  const el = document.getElementById('first_ambiance');
  if (el) showAmbiance(el.dataset.firstAmbiance);

  const firstVar = document.getElementById('first-var');
  if (firstVar) showqtt(firstVar.dataset.value);
});

document.addEventListener('change', function (e) {
  if (e.target.name === 'id') {
    // Variant ID dispo → on met à jour stock ET ambiance
    showqtt(e.target.value);
    showAmbiance(e.target.value);
  }
});


/* =============================================================================
   8. WISHLIST — Texte dynamique selon nb articles (#172)
   ============================================================================= */

function wish(cartCount) {
  const items = [];

  for (let i = 0; i < 5; i++) {
    items.push(document.getElementById('content' + i) || null);
  }

  /* Tout masquer */
  items.forEach(function (item) {
    if (item) item.classList.add('display_none');
  });

  /* Afficher l'item correspondant */
  const index  = cartCount;
  const target = index < items.length ? items[index] : items[3];

  if (target) target.classList.remove('display_none');
}

document.addEventListener('theme:cart:change', function (event) {
  requestAnimationFrame(function () {
    wish(event.detail.cartCount);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const cartCountEl = document.querySelector('cart-count.cart__items-count');
  if (!cartCountEl) return;
  wish(parseInt(cartCountEl.dataset.cartCount, 10) || 0);
});


/* =============================================================================
   9. COLLECTION — Compteur de produits en temps réel (#175)
   ============================================================================= */

(function () {
  async function fetchRealProductCount() {
    const countEl = document.getElementById('product-count');
    if (!countEl) return;

    try {
      const response = await fetch(window.location.pathname + window.location.search);
      const html     = await response.text();
      const doc      = new DOMParser().parseFromString(html, 'text/html');
      const newCount = doc.querySelector('#product-count');
      if (newCount) countEl.textContent = newCount.textContent;
    } catch (e) {
      console.error('Erreur comptage produits :', e);
    }
  }

  /* Interception des navigations SPA */
  const originalPushState    = history.pushState.bind(history);
  const originalReplaceState = history.replaceState.bind(history);

  history.pushState = function (...args) {
    originalPushState(...args);
    setTimeout(fetchRealProductCount, 100);
  };

  history.replaceState = function (...args) {
    originalReplaceState(...args);
    setTimeout(fetchRealProductCount, 100);
  };

  window.addEventListener('popstate', fetchRealProductCount);
})();


document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-unmute]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const video = btn.closest('.video-background').querySelector('video');
  if (!video) return;

  video.muted = !video.muted;
  video.volume = video.muted ? 0 : 1;

  const mutedIcon = btn.querySelector('.icon--muted');
  const soundIcon = btn.querySelector('.icon--sound');

  if (video.muted) {
    mutedIcon.style.display = '';
    soundIcon.style.display = 'none';
  } else {
    mutedIcon.style.display = 'none';
    soundIcon.style.display = '';
  }
});

/* =============================================================================
   10. INFOS BULLE  — infos bulle sur page produits
   ============================================================================= */

   document.addEventListener('DOMContentLoaded', function () {
  const tooltips = document.querySelectorAll('.pa-tooltip');
  const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  tooltips.forEach(function (tooltip) {
    const trigger = tooltip.querySelector('.pa-tooltip__trigger');
    const overlay = tooltip.querySelector('.pa-tooltip__overlay');
    if (!trigger || !overlay) return;

    if (!isMobile) {
      /* Desktop : hover */
      trigger.addEventListener('mouseenter', function () {
        overlay.classList.add('is-visible');
      });
      trigger.addEventListener('mouseleave', function () {
        overlay.classList.remove('is-visible');
      });
    } else {
      /* Mobile : clic pour ouvrir/fermer */
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        overlay.classList.toggle('is-visible');
      });

      document.addEventListener('click', function (e) {
        if (!tooltip.contains(e.target)) {
          overlay.classList.remove('is-visible');
        }
      });
    }
  });
});
